export { default as ClaimsOrdersSearch }      from "./ClaimsOrdersSearch";
export { default as MyAccount }               from "./MyAccount";
export { default as OrdersMenu }              from "./OrdersMenu";
export { default as OrdersSearchWidgetForm }  from "./OrdersSearchWidgetForm";
export { default as ReverseLogisticsMenu }    from "./ReverseLogisticsMenu";
export { default as NewsSideMenu }            from "./NewsSideMenu.vue";
export { default as ResourceLibrarySideMenu } from "./ResourceLibrarySideMenu.vue";